import { render, staticRenderFns } from "./CheckChangeRecords.vue?vue&type=template&id=f70c60ac&"
import script from "./CheckChangeRecords.vue?vue&type=script&lang=js&"
export * from "./CheckChangeRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports